import { render, staticRenderFns } from "./ProductRecomendationForm.vue?vue&type=template&id=73bbe109&"
import script from "./ProductRecomendationForm.vue?vue&type=script&lang=js&"
export * from "./ProductRecomendationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports